import React from 'react'
import { useSelector } from 'react-redux'
import StepOne from './StepOne/CSVDropZoneBox'

export default (props) => {
  const {
    initState,
    state,
    setState,
    classes,
    loadMore,
    placeId,
    isUpdatedStatus,
    apiFetchersCallback,
    toggleDialogs,
    showSnackbar,
  } = props

  const { selectedPlace } = useSelector(({ auth }) => auth.user)
  const isDisplayCareCheck = selectedPlace.info.shouldSeeCarecheck

  return (
    <StepOne
      initState={initState}
      placeId={placeId}
      setState={setState}
      state={state}
      classes={classes}
      toggleDialogs={toggleDialogs}
      apiFetchersCallback={apiFetchersCallback}
      showSnackbar={showSnackbar}
      isUpdatedStatus={isUpdatedStatus}
      loadMore={loadMore}
      isDisplayCareCheck={isDisplayCareCheck}
    />
  )
}
